import React, { useState } from "react";
import db from "./Firebase";
import { collection, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";

const SendAppNotifications = () => {
    const [formData, setFormData] = useState({
        actions: false,
        category: "",
        created_at: "",
        image: "",
        is_download: "",
        is_join: "",
        redirect_page: "",
        requested_phone_no: "",
        requested_user: "",
        seen_by: [],
        status: "1",
        timestamp: new Date(),
        title: "",
        type: "",
        user_id: "",
        created_at: new Date(),
        id: new Date().getTime() + new Date().getMilliseconds()
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, "nv_notifications"), {
                ...formData,
                created_at: Timestamp.fromDate(new Date()),
                timestamp: Timestamp.fromDate(new Date(formData.timestamp)),
            });
            alert("Notification added successfully!");
        } catch (error) {
            console.error("Error adding notification: ", error);
            alert("Error adding notification");
        }
    };

    return (
        <div className="p-6 max-w-lg mx-auto bg-white shadow-md rounded-lg w3layouts_payment_online_form" >
            <h2 className="text-2xl font-bold mb-4">Add Notification</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <ul>
                    <li> <label>Title</label>  <input type="text" name="title" placeholder="Title" value={formData.title} onChange={handleChange} className="w-full p-2 border rounded" required /></li>
                    <li> <label>Image</label> <input type="text" name="image" placeholder="Image URL" value={formData.image} onChange={handleChange} className="w-full p-2 border rounded" /></li>

                </ul>
                <ul>
                    {/* <li> <label>Actions</label>    <select class="form-control" name="actions" onChange={handleChange} >
                        <option value="">-- Actions --</option>
                        <option value="true">True</option>
                        <option value="false">False</option>
                    </select></li> */}
                    <li> <label>Category</label>    <select class="form-control" name="category" onChange={handleChange} >
                        <option value="">--Category --</option>
                        <option value="Learn">Learn</option>
                        <option value="Manage">Manage</option>
                        <option value="Grow">Grow</option>
                        <option value="Community">Community</option>
                        <option value="Aletr">Alert</option>
                    </select></li>

                </ul>

                <ul>
                    <li> <label>Is Download</label>    <select class="form-control" name="is_download" onChange={handleChange} >
                        <option value="">-- Is Download --</option>
                        <option value="yes">yes</option>
                        <option value="">no</option>
                    </select></li>
                    <li> <label>Is Join</label>    <select class="form-control" name="is_join" onChange={handleChange} >
                        <option value="">-- Is Join --</option>
                        <option value="yes">yes</option>
                        <option value="">no</option>
                    </select></li>

                </ul>
                <ul>

                    <li> <label>Page Redirect</label> <input type="text" name="redirect_page" placeholder="redirect_page" value={formData.redirect_page} onChange={handleChange} className="w-full p-2 border rounded" /></li>
                    <li> <label>Type</label>    <select class="form-control" name="type" onChange={handleChange} >
                        <option value="">-- Is Type --</option>
                        <option value="private">Private</option>
                        <option value="Global">Global</option>
                    </select></li>
                </ul>
                <button type="submit" className="w-full p-2 bg-blue-500 text-white rounded">Submit</button>
            </form>
        </div>
    );
};

export default SendAppNotifications;
